<template>
  <div>
      <!-- {{checkingSharedCourse}}
    <pre> {{ myCourseList }}</pre> -->
    
    <div class="cstm-wrapper">
      <div :class="{ activeNav: activeNav }" class="left-menu-sidebar">
        <!-- only for tab/mobile  -->
        <button
          @click="toggleNav"
          :class="{ rotate: activeNav }"
          class="hamburg-btn"
        >
          <feather-icon icon="ChevronRightIcon" />
        </button>

        <div class="course-cstm-heading">
          <feather-icon icon="FileTextIcon"/>
          <span class="ml-2">{{ myCourseList.name }}</span>
        </div>

        <!--SideNavbarMenuComponent -->
        <div class="p-4 menuNav">
          <p
            class="font-bold left-menu-name"
            :class="{ active: course }"
            @click="selectTab('course')"
          >
            Course Content
            <feather-icon icon="CheckCircleIcon"  v-if="myCourseList.courseComplete > 0" />
          </p>
          <vs-divider />
          <div
            v-for="(eachLesson, index) in myCourseList.courseLessons"
            :key="index"
          >
            <p
              class="font-bold left-menu-name"
              :class="[lesson && activeLessonIndex === index ? 'active' : '']"
              @click="selectTab('lesson', index)"
            >
              {{ eachLesson.lesson.name }}
              <feather-icon icon="CheckCircleIcon" 
              v-if="eachLesson.lesson.lesson_complete_count > 0"
              />
            </p>

            <vs-collapse
            :open="true"
              class="cstm-menu-collapse"
              v-if="eachLesson.lesson.lesson_topics.length"
            >
              <vs-collapse-item>
                <div slot="header">
                  <h6>
                    <span class="mr-2">{{
                      eachLesson.lesson.lesson_topics.length
                    }}</span
                    >Topic
                  </h6>
                </div>
                <div
                  v-for="(eachTopic, topicIndex) in eachLesson.lesson
                    .lesson_topics"
                  :key="topicIndex"
                >
                  <p
                    class="font-bold left-menu-name my-1"
                    :class="[
                      topic && activeTopicIndex === topicIndex && activeLessonIndex === index ? 'active' : '',
                    ]"
                    @click="selectTab('topic', index, topicIndex)"
                  >
                    {{ eachTopic.topic.name }}
                    <feather-icon icon="CheckCircleIcon" 
                     v-if="eachTopic.topic.topic_complete_count > 0"
                    />
                  </p>
                </div>
              </vs-collapse-item>
            </vs-collapse>
            <vs-divider />
          </div>
        </div>
        <!--SideNavbarMenuComponent -->
      </div>

      <div class="main-content">
        <!-- progress bar card  -->
        <vs-card>
          <div v-if="checkingSharedCourse"> 
            <div v-if="myCourseList.isCourseEnrolled === null">
              <div class="text-right">
                <vs-button
                 @click="submitCourseInterest(myCourseList.id, 3)">Enroll</vs-button>   
              </div>          
            </div>
             <!-- <div v-else-if ="myCourseList.isCourseEnrolled.enrollment_status === 1">
                <b>Shown interest and waiting for approval</b>       
            </div>
             <div class="flex items-center justify-between" v-else-if ="myCourseList.isCourseEnrolled.enrollment_status === 2"
             
             >
                <div><strong><p style="color: green">Approved from admin</p></strong> </div>
                <div> 
                <vs-button
                 @click="submitCourseInterest(myCourseList.id,3)">Confirmed Enrollment</vs-button>  
                </div>       
            </div> -->
             <div class="text-center" v-else-if ="myCourseList.isCourseEnrolled.enrollment_status === 3">
                <strong><p style="color: green">You have been enrolled for {{ myCourseList.name }}</p></strong>
            </div>
             <div class="text-center" v-else-if ="myCourseList.isCourseEnrolled.enrollment_status === 4">
                <strong><p style="color: red">Rejected By Admin</p></strong>   
            </div>
          </div>
        </vs-card>

        <div class="main-inner-content">
          <course-content
            v-if="course"
            :courseContent="myCourseList"
            @backToLesson="redirectToLesson"
          />
          <lessons
            v-if="lesson"
            :lessonContent="myCourseList"
            :lessonIndex="currentLessonIndex"
            @backToContent="redirectToContent"
            @backToLesson="redirectToLesson"
            @backToTopic="redirectToTopic"
          />
          <topics
            v-if="topic"
            :lessonContent="myCourseList"
            :lessonIndex="currentLessonIndex"
            :TopicIndex="currentTopicIndex"
            @backToContent="redirectToContent"
            @backToLesson="redirectToLesson"
            @backToTopic="redirectToTopic"
          />
        </div>
        <!-- {{currentLessonIndex}}
        {{currentTopicIndex}} -->
      </div>
    </div>
  </div>
</template>

<script>
import CourseContent from './components/Preview/CourseContent.vue'
import Lessons from './components/Preview/Lessons.vue'
import Topics from './components/Preview/Topics.vue'
import {coursePreview, submitCourseInterestapi} from '@/api/course-builderapi'


export default {
  name: 'PreviewComponent',
  components: {
    CourseContent,
    Lessons,
    Topics
  },
  data () {
    return {
      course: true,
      lesson: false,
      topic: false,
      content: false,
      files: false,
      activeNav: false,
      myCourseList: '',
      default_course_image: '',
      currentLessonIndex: '',
      currentTopicIndex: '',
      activeLessonIndex: undefined,
      activeTopicIndex: undefined,
      checkingSharedCourse:false,
      userId:''
    }
  },
  created () {
    this.fetchFullCourse()

  },
  //   computed () {
  //       checkingSharedCourse(){
  //           return
  //       }

  
  mounted () {
    // const client_user_id = this.$route.params.client_user_id
    // const course_name = this.$route.params.course_name
    // 
    // 
  },
  methods: {
    selectTab (type, index, topicIndex) {
      if (type === 'course') {
        this.course = true
        this.lesson = false
        this.topic = false
        this.content = false
        this.files = false
      } else if (type === 'lesson') {
        this.course = false
        this.lesson = true
        this.topic = false
        this.content = false
        this.files = false
        this.currentLessonIndex = index
        this.activeLessonIndex = index
      } else if (type === 'topic') {
        this.course = false
        this.lesson = false
        this.topic = true
        this.content = false
        this.files = false
        
        
        this.currentLessonIndex = index
        this.activeLessonIndex = index

        this.currentTopicIndex = topicIndex
        this.activeTopicIndex = topicIndex
      }
    },
    toggleNav () {
      this.activeNav = !this.activeNav
    },

    async fetchFullCourse () {
      try {
        this.$vs.loading({
          text: 'Fetching Course List'
        })
        // const queryParams = this.$route.query || {}
        // this.query_page.page = queryParams.page || 1
        const responseClient = await coursePreview(
          this.$route.params.courseSlug
        )
        
        this.myCourseList = responseClient.data.data.courselist[0]
        // 
        this.default_course_image =
          responseClient.data.data.default_course_image

        // const type = this.$route.params.type 
        // const lessonIndex = this.$route.params.lessonIndex 
        // const topicIndex = this.$route.params.topicIndex 
        const userInfo = JSON.parse(localStorage.getItem('userInfo'))
        const userId = userInfo.id
        this.userId = userInfo.id
        if (userId) {

          this.checkingSharedCourse = this.myCourseList.sharedUserList.some(ele => ele.to_user_id === userId)
        }

        this.selectTab('course', null, null)
        
        // 


      } catch (error) {
        
        this.$vs.loading.close()
      } finally {
        this.$vs.loading.close()
      }
    },
    redirectToContent () {
      
      this.selectTab('course', null, null)
    },
    redirectToLesson (index) {
      
      
      this.selectTab('lesson', index, null)
    },
    redirectToTopic (index, topicIndex = 0) {
      
      
      
      this.selectTab('topic', index, topicIndex)
    },
    async submitCourseInterest (id, status) {
    
      try {
        this.$vs.loading({
          text:'Submitting Interest in this course'
        })
        const payload = {  
          course_id: id,
          enrollment_status:status,
          user_id:this.userId
        }

        const customer_id = localStorage.getItem('customer_id')

        
 

        const data = await submitCourseInterestapi(payload, customer_id)
         this.showSuccessMessage('Success', 'Enrollment process has been started', 'success')
        this.myCourseList.isCourseEnrolled = {}
        this.myCourseList.isCourseEnrolled.enrollment_status = status
        
        

      } catch (error) {
        
        this.$vs.loading.close()
        this.showSuccessMessage('Error', error.data.message, 'danger')
        


      } finally {
        
        this.$vs.loading.close()
      }
    }
    // checkingShareCourse () {
    //   const userInfo = JSON.parse(localStorage.getItem('userInfo'))
    //   const userId = userInfo.id
    //   //   return this.myCourseList.sharedUserList
    //   
     

    // }
  }
}
</script>

<style>
.left-menu-name .feather-icon {
  float: right;
  color: #28c76f;
}
.left-menu-name svg {
  width: 18px;
}
</style>
